import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { PriceService } from '../price.service';
import { Sort } from 'src/app/core/services/sort';


@Component({
  selector: 'app-price-deep-drive',
  templateUrl: './price-deep-drive.component.html',
  styleUrls: ['./price-deep-drive.component.scss']
})
export class PriceDeepDriveComponent implements OnInit {
  formDetails: any = {};
  selectedValues: any = {};
  qParam: any = {};
  engine: any;
  channelData: any = [];
  channelHidden: { [index: number]: boolean } = {};
  businessHidden: { [index: number]: boolean } = {};
  segmentHidden: { [index: number]: boolean } = {};
  activeChannel: string = '';
  cached: {
    [channel_new: string]: {
      [business: string]: {
        [lob_segment_2: string]: boolean;
      };
    };
  } = {};
  hierarchy: string = '';
  selectedButton: string = 'All';
  currentFilter: string = '';
  tableHead: string = 'LOB Segment';
  suffix: number = 0;
  sortOrderAsc: boolean | undefined;
  activeSort: any;
  regionHidden: { [index: number]: boolean; } | undefined;
  cdr: any;
  previousHierarchy: string = '';
  segmentDropdownValues: any;
  constructor(
    private sortService: Sort,
    private service: PriceService,
    public localStore: LocalStorageService
  ) { }
  ngAfterViewChecked() {
    const activeElement = document.querySelector('.active-revised_customer_name');
    if (activeElement) {
      activeElement.scrollIntoView();
      activeElement.classList.remove('active-revised_customer_name');
    }
  }
  ngOnInit(): void {
    this.selectedValues =
      this.localStore.getItem<any>('engineDropdown') != undefined
        ? this.localStore.getItem<any>('engineDropdown')
        : null;

    this.qParam = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    this.searchFilters();
    if (this.selectedButton == 'All') {
      this.getChannel('ext_int/all');
    } else {
      this.getChannel(this.selectedButton + '/all');
    }
  }
  searchFilters() {


    let reg = {
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let businessView = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let subBusinessView = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let lobSegment = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let channelType = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let engineModel = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    let chan = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let customerName = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let waveInitiative = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };

    let classific = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      product_flag: this.selectedValues.product_flag,
    };

    let productFlag = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
    };

    if (this.currentFilter != 'financial_reporting_region') {
      reg['current_dropdown'] = 'financial_reporting_region';
      this.getDropdowndetails(reg);
    }


    if (this.currentFilter != 'business_view') {
      businessView['current_dropdown'] = 'business_view';
      this.getDropdowndetails(businessView);
    }

    if (this.currentFilter != 'sub_business_view') {
      subBusinessView['current_dropdown'] = 'sub_business_view';
      this.getDropdowndetails(subBusinessView);
    }

    if (this.currentFilter != 'lob_segment_2') {
      lobSegment['current_dropdown'] = 'lob_segment_2';
      this.getDropdowndetails(lobSegment);
    }

    if (this.currentFilter != 'type') {
      channelType['current_dropdown'] = 'type';
      this.getDropdowndetails(channelType);
    }

    if (this.currentFilter != 'revised_product_family_standard') {
      engineModel['current_dropdown'] = 'revised_product_family_standard';
      this.getDropdowndetails(engineModel);
    }

    if (this.currentFilter != 'channel_new') {
      chan['current_dropdown'] = 'channel_new';
      this.getDropdowndetails(chan);
    }
    if (this.currentFilter != 'revised_customer_name') {
      customerName['current_dropdown'] = 'revised_customer_name';
      this.getDropdowndetails(customerName);
    }
    if (this.currentFilter != 'wave_initiative') {
      waveInitiative['current_dropdown'] = 'wave_initiative';
      this.getDropdowndetails(waveInitiative);
    }
    if (this.currentFilter != 'classification') {
      classific['current_dropdown'] = 'classification';
      this.getDropdowndetails(classific);
    }
    if (this.currentFilter != 'product_flag') {
      productFlag['current_dropdown'] = 'product_flag';
      this.getDropdowndetails(productFlag);
    }


  }
  getDropdowndetails(type) {

    this.service
      .getHhpDropDownDetails(type, '/hhp/price/dropdown')
      .subscribe((results) => {
        let values: any[] = [];
        if (type.current_dropdown == 'financial_reporting_region') {
          values = results.financial_reporting_region;
        }
        if (type.current_dropdown == 'business_view')
          values = results.business_view;
        if (type.current_dropdown == 'sub_business_view')
          values = results.sub_business_view;
        if (type.current_dropdown == 'lob_segment_2'){
          values = results.lob_segment_2;
          this.segmentDropdownValues = results.lob_segment_2
        }
        if (type.current_dropdown == 'type')
          values = results.type;
        if (type.current_dropdown == 'revised_product_family_standard')
          values = results.revised_product_family_standard;
        if (type.current_dropdown == 'channel_new') 
          values = results.channel_new;
        if (type.current_dropdown == 'revised_customer_name')
          values = results.revised_customer_name;
        if (type.current_dropdown == 'classification')
          values = results.classification;
        if (type.current_dropdown == 'product_flag')
          values = results.product_flag;
        if (type.current_dropdown == 'wave_initiative')
          values = results.wave_initiative;

        const resp = [...new Set(values)];
        if (type.current_dropdown == 'financial_reporting_region') {
          this.formDetails['financial_reporting_region'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'business_view') {
          this.formDetails['business_view'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'sub_business_view') {
          this.formDetails['sub_business_view'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'lob_segment_2') {
          this.formDetails['lob_segment_2'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'type') {
          this.formDetails['type'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'revised_product_family_standard') {
          this.formDetails['revised_product_family_standard'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'channel_new') {
          this.formDetails['channel_new'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'revised_customer_name') {
            this.formDetails['revised_customer_name'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'wave_initiative') {
          this.formDetails['wave_initiative'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'classification') {
          this.formDetails['classification'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'product_flag') {
          this.formDetails['product_flag'] =
              resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        this.formDetails = { ...this.formDetails };
      });
  }
  searchSalesData(event) {
    this.currentFilter = event.type;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.searchFilters();
    if (this.selectedButton == 'All') {
      this.getChannel('ext_int/all');
    } else {
      this.getChannel(this.selectedButton + '/all');
    }
  }
  getChannel(url) {
    let dropdown = {
      financial_reporting_region: this.selectedValues.financial_reporting_region,
      business_view: this.selectedValues.business_view,
      sub_business_view: this.selectedValues.sub_business_view,
      lob_segment_2: this.selectedValues.lob_segment_2,
      type: this.selectedValues.type,
      revised_product_family_standard: this.selectedValues.revised_product_family_standard,
      channel_new: this.selectedValues.channel_new,
      revised_customer_name: this.selectedValues.revised_customer_name,
      wave_initiative: this.selectedValues.wave_initiative,
      classification: this.selectedValues.classification,
      product_flag: this.selectedValues.product_flag,
    };
    this.localStore.createItem<any>('engineDropdown', dropdown);
    this.service.priceTable(this.qParam, '/lobsegment').subscribe((results: any) => {
      this.channelData = results || [];
      this.channelHidden = { 0: false };
      this.businessHidden = { 0: false };
      this.segmentHidden = { 0: false };
      this.activeChannel = '';
    });
  }
  selectedDiamension(event) {
    this.selectedButton = event;
    if (this.selectedButton == 'All') {
      this.tableHead = 'Ext/Int';
      this.getChannel('ext_int/all');
    } else {
      this.getChannel(this.selectedButton + '/all');
      this.tableHead = event;
    }
  }
  // getParentData(
  //   rowId: number,
  //   itemIndex: number,
  //   type: string,
  //   item: any,
  //   callNext: any = null
  // ) {
  //       this.activeChannel = '';
  //       this.channelHidden = { [rowId]: !this.channelHidden[rowId] };
  //       this.businessHidden = {};
  //       this.segmentHidden = {};
  //       this.getClassifications(item, rowId, callNext);

  // }



  getParentData(
    rowId: number,
    itemIndex: number,
    type: string,
    item: any,
    callNext: any = null
  ) {
    switch (type) {
      case 'channel':
        this.activeChannel = '';
        this.channelHidden = { [rowId]: !this.channelHidden[rowId] };
        this.businessHidden = {};
        this.segmentHidden = {};
        this.getBusiness(item, rowId, callNext);
        break;
      case 'business':
        this.businessHidden = {
          [itemIndex]: !this.businessHidden[itemIndex],
        };
        this.segmentHidden = {};
        this.getSegment(item, rowId, callNext);
        break;
      case 'customer':
        this.segmentHidden = { [itemIndex]: !this.segmentHidden[itemIndex] };
        break;
      default:
    }
  }

  getBusiness(item: any, i: number, callNext: any) {
    this.hierarchy = item.hierarchy;
    if (!this.cached[item.id]) {
      this.service
        // .summaryTable(this.qParam, this.hierarchy + '/segment/all')
        .getClassificationTable(this.qParam, this.hierarchy + '/classification')
        .subscribe((results: any) => {
          const businessData = results || [];
          if (businessData) {
            this.cached[item.id] = {};
            this.channelData[i]['business'] = businessData.map(
              (value: any, index: number) => {
                value.businessIndex = index;
                value.channel = item.id;
                value.business = item;
                return value;
              }
            );
            if (callNext) {
              const businessId = businessData.findIndex(
                (item: any) => item.id === callNext.business
              );
              if (businessId !== -1) {
                this.activeChannel = this.channelData[i].id;
                this.getParentData(
                  i,
                  businessId,
                  'business',
                  businessData[businessId],
                  callNext
                );
              }
            }
          }
        });
    }
  }
  getSegment(item: any, i: number, callNext: any) {
    // if (this.channelDropdownValues.includes(this.hierarchy)) {
    //   this.previousHierarchy = this.hierarchy;
    // }
    this.hierarchy = item.hierarchy;
    if (!this.cached[item.channel][item.id]) {
      this.service
        //  .summaryTable(this.qParam, this.hierarchy + '/customer/all')
        // .gettable()
        // .getCustomerTable(this.qParam, this.previousHierarchy + '/' + this.hierarchy + '/customer/all')
        .getClassificationTable(this.qParam, this.hierarchy + '/classification')
        .subscribe((results: any) => {
          const segmentData = results || [];
          if (segmentData) {
            this.cached[item.channel][item.id] = {};
            this.channelData[i]['business'][item.businessIndex]['customer'] =
              segmentData.map((value: any, index: number) => {
                value.segmentIndex = index;
                value.businessIndex = item.businessIndex;
                value.channel = item.channel;
                value.business = item.id;
                return value;
              });
            if (callNext) {
              const segmentId = segmentData.findIndex(
                (item: any) => item.business === callNext.segment
              );
              if (segmentId !== -1) {
                this.getParentData(
                  i,
                  segmentId,
                  'customer',
                  segmentData[segmentId],
                  callNext
                );
              }
            }
          }
        });
    }
  }



  getClassifications(item: any, i: number, callNext: any) {
    this.hierarchy = item.hierarchy;
    if (!this.cached[item.id]) {
      this.service
        .getClassificationTable(this.qParam, this.hierarchy + '/classification')
        .subscribe((results: any) => {
          const businessData = results || [];
          if (businessData) {
            this.cached[item.id] = {};
            this.channelData[i]['business'] = businessData.map(
              (value: any, index: number) => {
                value.businessIndex = index;
                value.channel_new = item.id;
                value.business = item;
                return value;
              }
            );
            if (callNext) {
              const businessId = businessData.findIndex(
                (item: any) => item.id === callNext.business
              );
              if (businessId !== -1) {
                this.activeChannel = this.channelData[i].id;
                this.getParentData(
                  i,
                  businessId,
                  'business',
                  businessData[businessId],
                  callNext
                );
              }
            }
          }
        });
    }
  }


  resetFilter(event) {
    this.selectedValues['financial_reporting_region'] = ['All'];
    this.selectedValues['business_view'] = ['All'];
    this.selectedValues['sub_business_view'] = ['All'];
    this.selectedValues['lob_segment_2'] = ['All'];
    this.selectedValues['type'] = ['All'];
    this.selectedValues['revised_product_family_standard'] = ['All'];
    this.selectedValues['channel_new'] = ['All'];
    this.selectedValues['revised_customer_name'] = ['All'];
    this.selectedValues['wave_initiative'] = ['All'];
    this.selectedValues['product_flag'] = ['All'];
    this.selectedValues['classification'] = ['All'];

    this.qParam = this.selectedValues;
    this.currentFilter = '';
    this.searchFilters();
    this.selectedButton = 'All';
    this.tableHead = 'Ext/Int';
    this.getChannel('ext_int/all');
    this.suffix = 0;
  }
  setSuffix(event) {
    this.suffix = event;
  }
  sortColumn(column, type) {
    this.sortOrderAsc = this.activeSort === column ? !this.sortOrderAsc : false;
    this.activeSort = column;
    if (this.channelHidden) {
      this.channelData = this.sortService.sortTable(
        this.channelData,
        type,
        this.sortOrderAsc,
        column
      );
    }
    if (this.channelHidden && this.segmentHidden) {
      this.channelData.map((value: any, index: number) => {
        if (this.channelData[index].segment) {
          this.channelData[index].segment = this.sortService.sortTable(
            this.channelData[index].segment,
            type,
            this.sortOrderAsc,
            column
          );
        }
      });
    }
    if (this.channelHidden && this.segmentHidden && this.regionHidden) {
      this.channelData.map((value: any, index: number) => {
        if (
          this.channelData[index]?.segment &&
          this.channelData[index]?.segment[index].financial_reporting_region
        ) {
          this.channelData[index].segment[index].financial_reporting_region =
            this.sortService.sortTable(
              this.channelData[index].segment[index].financial_reporting_region,
              type,
              this.sortOrderAsc,
              column
            );
        }
      });
    }
    // this.cdr.detectChanges();
  }
}
